export default "/images/physical_activity_scheduling_sm.jpg?ea4a495c80b11b7728f07c5c24f37b41";